export { default as isMailFeatureEnabled } from './isMailFeatureEnabled';
export { default as is3SFeatureEnabled } from './is3SFeatureEnabled';
export { default as mailFeatures } from './mailFeatures';
//# sourceMappingURL=index.js.map